import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {StudentNote} from '../student-note.model';
import {AutoUnsubscribe} from 'ngx-auto-unsubscribe';
import {StudentNotesService} from '../student-notes.service';

@AutoUnsubscribe()
@Component({
	selector: 'delete-note-dialog',
	templateUrl: './delete-note-dialog.component.html',
	styleUrls: [
		'./delete-note-dialog.component.css'
	]
})
export class DeleteNoteDialogComponent implements OnInit, OnDestroy {

	// Properties
	note: StudentNote;

	// Class Functions
	constructor(
		@Inject(MAT_DIALOG_DATA) private data: any,
		private dialogBox: MatDialogRef<any, any>,
		private studentNoteService: StudentNotesService
	) { }

	// Event Functions
	ngOnInit() {
		// POST: initializes the data
		if (this.data) {
			this.note = this.data.note;
		}
	}

	ngOnDestroy() {
		// NOTE: this is implemented for @AutoUnsubscribe
	}

	OK() {
		// PRE: the OK button is clicked
		// POST: deletes the note and closes the dialog
		this.studentNoteService.deleteStudentNote(this.note.Id).subscribe(() => {
			this.dialogBox.close(true);
		});
	}

	cancel() {
		// PRE: the cancel button is clicked
		// POST: closes the dialog
		this.dialogBox.close(false);
	}

	// Methods
}